import { ROUTES } from "@/constants/routes";
import { useAuthState } from "@/store/auth";
import { useMemo } from "react";

export const useGetProfilePath = (profilePath: string, pathname: string) =>
  useMemo(() => {
    const accountInfoPaths = [
      ROUTES.Profile.Children.AccountInfo,
      ROUTES.Profile.Children.Addresses,
    ];

    const overviewPaths = [
      ROUTES.Profile.Children.Packages,
      ROUTES.Profile.Children.Overview,
      ROUTES.Profile.Children.CreditAccount,
    ];

    // @ts-expect-error
    const isInsideAccountInfo = accountInfoPaths.includes(profilePath);
    // @ts-expect-error
    const isInsideOverview = overviewPaths.includes(profilePath);

    return { isInsideAccountInfo, isInsideOverview };
  }, [pathname, profilePath]);

export const useGetReferralPath = (pathname: string) =>
  useMemo(() => {
    const isInsideAccountMyReferral =
      pathname
        ?.replaceAll("/profile", "")
        .includes(ROUTES.Profile.Children.AccountMyReferral) ||
      pathname
        ?.replaceAll("/profile", "")
        .includes(ROUTES.Profile.Children.AccountMyReferralHistory);

    return { isInsideAccountMyReferral };
  }, [pathname]);

export const useGetPaymentPath = () => {
  const paymentMethod = useAuthState(({ data }) => data.userInfo.paymentMethod);
  const paymentRoute = useMemo((): string => {
    if (paymentMethod) {
      return ROUTES.Profile.Children.Payment;
    } else return ROUTES.Profile.Children.AddCreditCard;
  }, [paymentMethod]);

  return { paymentRoute };
};
